import { redirect } from 'redux-first-router';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { ACCOUNT_INFORMATION_VIEW } from '../../AccountInfo/module/accountInfo';
import { RENEW_SUBSCRIPTION_VIEW } from '../../PaymentInformation/module';

// ------------------------------------
// View / Route
// ------------------------------------
export const SUBSCRIBE_NEW_VIEW = 'SUBSCRIBE_NEW_VIEW';

viewNames[SUBSCRIBE_NEW_VIEW] = 'Subscribe';
routes[SUBSCRIBE_NEW_VIEW] = {
  path: '/subscribe',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    const accountStatus = getState().auth.user.status;
    const isExpired = !(accountStatus === 'A' || !accountStatus);
    if (loggedIn && isExpired) dispatch(redirect({ type: RENEW_SUBSCRIPTION_VIEW }));
    if (loggedIn && !isExpired) dispatch(redirect({ type: ACCOUNT_INFORMATION_VIEW }));
  },
};

export const SUBSCRIBE_TMOBILE_VIEW = 'SUBSCRIBE_TMOBILE_VIEW';

viewNames[SUBSCRIBE_TMOBILE_VIEW] = 'Subscribe/TMobile';
routes[SUBSCRIBE_TMOBILE_VIEW] = {
  path: '/subscribe/t-mobile',
  thunk: async (dispatch, getState) => {
    const { loggedIn } = getState().auth;
    const accountStatus = getState().auth.user.status;
    const isExpired = !(accountStatus === 'A' || !accountStatus);
    if (loggedIn && isExpired) dispatch(redirect({ type: RENEW_SUBSCRIPTION_VIEW }));
    if (loggedIn && !isExpired) dispatch(redirect({ type: ACCOUNT_INFORMATION_VIEW }));
  },
};

export const GO_LEARN_MORE = 'GO_LEARN_MORE';

viewNames[GO_LEARN_MORE] = 'LearnMore';
routes[GO_LEARN_MORE] = {
  path: '/learn-more',
  thunk: async dispatch => {
    dispatch(redirect({ type: GO_LEARN_MORE }));
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Subscribe/module/subscribe.js